<div class="modal-header">
  <h4 class="modal-title">{{ 'configurations.pendingTitle' | translate }}</h4>
  <button
    type="button"
    aria-label="Close"
    class="btn-close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <div>{{ 'configurations.pendingQuestion' | translate }}</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="close()">
    {{ 'cancel' | translate }}
  </button>
  <button class="btn btn-primary" type="submit" (click)="confirmDownload()">
    {{ 'download' | translate }}
  </button>
</div>
